import axios from '@/services/axios';
import { clearPerms } from '@/composables/usePerms';
import { clearTemplates } from '@/composables/useTextTemplates';
import { clearUserStatus } from '@/composables/useUserStatus';
import { clearActAs } from '@/composables/useActAs';
import { clearTaskListFilters } from '@/utils/taskFilters';

// Ends the API session and drops everything the next user on the device must
// not inherit. The MSAL popup logout (Microsoft users) is done by the caller.
export async function performLogout(router) {
    try {
        await axios.post('/logout');
    } catch (error) {
        console.error("API Logout error", error);
    }

    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('loginMethod');
    clearPerms();
    // In-memory only, but drop it now so the next user cannot see the
    // previous one's templates in the window before their own load lands.
    clearTemplates();
    clearUserStatus();
    clearActAs();
    // These do outlive the session in localStorage, so the next user on a
    // shared device would otherwise inherit the previous one's filters.
    clearTaskListFilters();

    router.push('/login');
}
